<form class="ps-flex-container-col" *ngIf="!radioSelection" style="padding: 12px">
  <h3>{{'orders.overlays.createPlannedDelivery.typeOfDelivery' | translate}}</h3>
  <mat-radio-group class="ps-flex-container-col" (change)="onRadioChange($event)"
                   *ngIf="validatedPboSubtypes?.length > 0; else noSubtypes">
    <mat-radio-button *ngFor="let pbo of validatedPboSubtypes" [value]="pbo.guid">{{pbo.description}}</mat-radio-button>
  </mat-radio-group>
  <ng-template #noSubtypes>
    <div>{{'orders.overlays.createPlannedDelivery.noValidPboSubtypes' | translate}}.</div>
  </ng-template>
</form>

<form class="ps-flex-container-col" *ngIf="radioSelection" [formGroup]="formGroup">
  <h3>{{'orders.overlays.createPlannedDelivery.createPlannedDelivery' | translate}}</h3>

  <mat-error>
    <span *ngIf="formGroup.errors?.mismatchedCount">
     {{'orders.overlays.createPlannedDelivery.mismatchedCount' | translate}}
    </span>
  </mat-error>

  <mat-form-field appearance="fill">
    <mat-label>
      {{'orders.overlays.createPlannedDelivery.plannedNrOfPieces' | translate}}
      <span
        style="color: red">({{incident?.PARTS_AFFECTED}} {{'orders.overlays.createPlannedDelivery.partsAffected' | translate}}
        )</span>
    </mat-label>
    <input matInput type="text" required="true" formControlName="plannedCountControl">
    <mat-error>
      <span *ngIf="!formGroup.get('plannedCountControl').valid">
        {{'orders.overlays.createPlannedDelivery.fillInPlannedCount' | translate}}
      </span>
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>{{'orders.overlays.createPlannedDelivery.plannedDeliveryDate' | translate}}</mat-label>
    <input matInput [matDatepicker]="picker" formControlName="plannedDateControl">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-error *ngIf="!formGroup.get('plannedDateControl').valid">
      {{'orders.overlays.createPlannedDelivery.selectDeliveryDate' | translate}}
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>{{'orders.overlays.createPlannedDelivery.deliveryComment' | translate}}</mat-label>
    <input matInput formControlName="deliveryCommentControl">
    <mat-error
      *ngIf="!formGroup.get('deliveryCommentControl').valid">{{'orders.overlays.createPlannedDelivery.commentMustHaveAtLeast1Char' | translate}}
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="fill" *ngIf="isQsDelivery()">
    <mat-label>{{'orders.overlays.createPlannedDelivery.incident' | translate}}</mat-label>
    <mat-select formControlName="deliveryIncident" [compareWith]="compareIncidents">
      <mat-option *ngFor="let incident of incidents$ | async" [value]="incident">
        {{incident.TEXT}} <span
        style="color: red">({{incident.PARTS_AFFECTED}} {{'orders.overlays.createPlannedDelivery.partsAffected' | translate}}
        )</span>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div>
    <button mat-button (click)="createPlannedDelivery()"
            [disabled]="!formGroup.valid">{{'orders.overlays.createPlannedDelivery.save' | translate}}</button>
    <button mat-button (click)="dismiss()">{{'orders.overlays.createPlannedDelivery.cancel' | translate}}</button>
  </div>

</form>

